
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Share2 } from 'lucide-react';
import ShareContent from './ShareContent';

interface ShareButtonProps {
  title: string;
  url: string;
}

const BlogShareButtons: React.FC<ShareButtonProps> = ({ title, url }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-2 rounded-full h-9 px-4 text-joerg-700 dark:text-joerg-200 hover:text-primary dark:hover:text-primary-light hover:bg-joerg-50 dark:hover:bg-joerg-800 border-joerg-300 dark:border-joerg-700 font-medium transition-colors"
          aria-label="Diesen Artikel teilen"
        >
          <Share2 className="h-4 w-4" />
          <span>Teilen</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent 
        side="top" 
        align="start" 
        className="w-[280px] p-4"
      >
        <ShareContent title={title} url={url} />
      </PopoverContent>
    </Popover>
  );
};

export default BlogShareButtons;
